import { useRef, useEffect } from 'react';

const useFocus = () => {
  const focusRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (focusRef.current) {
      focusRef.current.focus();
    }
  }, []);

  return focusRef;
};

export default useFocus;